<template>
  <div>
    this is order page!
  </div>
</template>

<style scoped>

</style>

<script>
  import Order from "./order.ts";
  export default Order;
</script>